import { func_file, isNotNullUndefined } from 'functions';
import { useCustomSelector } from 'hooks';

export default function useExportData() {

    function exportData(data) {
        // Set Header Names
        let headers = [
            [
                "Store Code",
                "Store Name",
                "Address 1",
                "Address 2",
                "Post Code",
                "City",
                "State",
                "Active Date",
                "Operation Hours",
            ],
        ];

        // Columns Widths
        let columnWidths = headers[0].map((header, idx) => {
            return {
                wch: idx == 1 || idx == 2? 50: header.length
            }
        });

        // Set rows data
        let rows = data.map((rowDetail) => {
            return [
                (rowDetail?.StoreCode? rowDetail.StoreCode: ""),
                (rowDetail?.StoreName? rowDetail.StoreName: ""),
                (rowDetail?.Address1? rowDetail.Address1: ""),
                (rowDetail?.Address2? rowDetail.Address2: ""),
                (isNotNullUndefined(rowDetail?.PostCode)? rowDetail.PostCode: ""),
                (rowDetail?.City? rowDetail.City: ""),
                (rowDetail?.State? rowDetail.State: ""),
                (rowDetail?.Active_date? rowDetail.Active_date: ""),
                (rowDetail?.Operation_hours? rowDetail.Operation_hours: ""),
            ]
        });

        func_file.generateFile_XLSX("Store Report", "Unposted Invoices", headers, rows, null, null, columnWidths);
    }

    return exportData;
}